package ca.northroot.app.utils

import kotlinx.browser.window

actual object PlatformUtils {
    actual fun launchSms(phoneNumber: String, message: String) {
        window.open("sms:$phoneNumber?body=${message.replace(" ", "%20")}", "_blank")
    }

    actual fun launchMap(address: String) {
        window.open("https://www.google.com/maps/search/?api=1&query=${address.replace(" ", "+")}", "_blank")
    }

    actual fun launchDialer(phoneNumber: String) {
        window.open("tel:$phoneNumber", "_blank")
    }
}
